import { primaryColor } from "../../utils/theme";
import {
  Chip,
  Button
} from "@mui/material";
import styled from "styled-components";

interface StatusTagProps {
  status: 'Active' | 'Pending' | 'Blocked' | string;
}

export const StatusChip = styled(Chip)<StatusTagProps>(({ theme, status }) => ({
  fontWeight: 'bold',
  color: "#fff !important",
  height: '28px',
  padding: `${theme.spacing(1, 5)} !important`,
  display: 'flex !important',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  borderRadius: `${theme.spacing(1, 3)} !important`,
  textTransform: 'capitalize',
}))

export const StatusButton = styled(Button)<{ status: string }>(({ theme, status }) => {
  let color: string;

  switch (status) {
    case 'active':
    case 'approved':
      color = theme.palette.error.main;;
      break;
    default:
      color = primaryColor;
  }

  return {
    padding: "5px 30px",
    borderRadius: theme.spacing(1),
    borderWidth: '2px',
    fontWeight: 'bold',
    color: color,
    borderColor: color,
  }
});